import React, { useEffect, useState  } from 'react';
import './style.scss';
import { Link} from 'react-router-dom';
import Slider from 'react-slick';
import {loadSlickCSS} from '../../shared/helpers';
import { TranslatableText } from '../../providers/LanguageProvider';
import { tl } from '../../shared/helpers';
import { tl_data } from './translations.js';
import AwNextArrow from '../SliderWrap/AwNextArrow';
import AwPrevArrow from '../SliderWrap/AwPrevArrow';
import arrow from '../../assets/images/hero-arrow.png';

const IngredientsSlider = (props) => {
    const allList = ['beef', 'chicken', 'eggs', 'pork', 'beyond-meat', 'root-beer', 'coffee', 'tomatoes', 'onions', 'lettuce', 'cheese'];
    const [ingredientsList, setIngredientsList] = useState(allList);
    //const [titleFr, setTitleFr] = useState('Nos'); 
    const [arrowVisible, setArrowVisible] = useState(true);
    useEffect(() => {
       
        let currentPage = props.currentPage;
       
        if(currentPage.match(/^(beef|chicken|eggs|pork|beyond-meat|coffee|root-beer|tomatoes|onions|lettuce|cheese)$/)){
            //console.log('match ingredient');
            let newList = ingredientsList.filter((item) => {
                return item !== currentPage;
            })
            setIngredientsList(newList);
        }
    },[props.currentPage]);

    useEffect(() => {
        loadSlickCSS()
        console.log('children ',props.children);
    },[props.children]);

    let displayList = ingredientsList.map((item, i) => {
        // Set path to images (this is needed for dynamic paths)
        const images = require.context('./i', true);
        // Set image
        let img = images('./' + item + '-explore-more.jpg');

        let titleFr = item.match(/^(beef|chicken|pork|coffee|root-beer|lettuce|cheese)$/) ? 'Notre' : 'Nos';
       
        return (
            <div key={i} className={`item ${item}`}>
                <Link to={`/${props.lang}/our-values/our-food/${item}`} className="itemcol">
                    <img src={`${img}`} className="" alt=""  /> 
                    <h3>
                        {
                        item !== 'beyond-meat' && <span className="our-text ">
                            <TranslatableText 
                                dictionary={{ 
                                    en: "Our", 
                                    fr: titleFr }}>
                            </TranslatableText></span>
                        }
                        {tl(tl_data, item, props.lang)}<sup className="menu-dagger">†</sup>  
                    </h3>
                </Link>
            </div>
        )
    })

    let settings = {
        className: "center",
        swipeToSlide: true,
        centerMode: true,
        infinite: true,
        centerPadding: "80px",
        slidesToShow: 3,
        dots:false,
        speed: 500,   
        nextArrow: <AwNextArrow />,
        prevArrow: <AwPrevArrow />,
        afterChange: () =>
        setArrowVisible(false),
  
        responsive: [
            {
                breakpoint:850,
                settings: {
                    className: "center",
                    swipeToSlide: true,
                    centerMode: true,
                    infinite: true,
                    centerPadding: "80px",
                    slidesToShow: 1,
                    dots:false,
                    speed: 500,
                    arrows:false
                }
            }
        ]
      };
  

    return (
        <div className="blockwrap ingredients-slider">
            <div className="explore-block">
                <h2><TranslatableText 
                    dictionary={{ 
                        en: "Explore ", 
                        fr: "Explorer "}}>
                    </TranslatableText><span><TranslatableText 
                        dictionary={{ 
                            en: "More Ingredients", 
                            fr: "plus d’ingrédients"}}>
                    </TranslatableText></span>
                </h2>
            </div>
            <div className="slider-wrap">
                <Slider {...settings}>
                    {displayList}
                </Slider>
                {!props.isDesktop && 
                    <span className="bounce-wrap"><img src={arrow} alt="arrow" className={`arrow side-bounce ${arrowVisible ? '' : 'hide'}`}/></span>
                }
            </div>
            
        </div>

    )
}
export default IngredientsSlider;